/* Unbox Collectibles: compromiso de compra también en la puja automática (proxy) de Webkul.
   Complementa el script del bloque Custom Liquid del producto (wk_compromiso_compra),
   que solo cubre el formulario normal (#bidding-form). */
(function () {
  var MAIN = 'wk_compromiso_compra';
  var PROXY = 'wk_compromiso_proxy';
  var FORM = 'proxy_bidding_form';

  function ok() {
    var p = document.getElementById(PROXY);
    return !!(p && p.checked);
  }

  function sync(from) {
    var m = document.getElementById(MAIN);
    var p = document.getElementById(PROXY);
    if (!m || !p || m.checked === p.checked) return;
    if (from === MAIN) p.checked = m.checked;
    else {
      m.checked = p.checked;
      m.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function upd() {
    var f = document.getElementById(FORM);
    if (!f) return;
    f.classList.toggle('wk-ok', ok());
    f.querySelectorAll('.wk_proxy_submit').forEach(function (b) {
      b.style.opacity = ok() ? '' : '0.45';
      b.style.cursor = ok() ? '' : 'not-allowed';
    });
    var e = f.querySelector('.wk-compromiso-error');
    if (e && ok()) e.style.display = 'none';
  }

  function inject() {
    var f = document.getElementById(FORM);
    if (!f || document.getElementById(PROXY)) return;
    var btn = f.querySelector('.wk_proxy_submit');
    if (!btn) return;
    var w = document.createElement('div');
    w.className = 'margin-btm-15 noselect wk-compromiso';
    w.innerHTML =
      '<input type="checkbox" class="pa-checkbox" id="' + PROXY + '">' +
      '<label for="' + PROXY + '" class="pa-bdr"><div class="pa-theme-color">&#10003;</div></label>' +
      '<span class="margin-left-5 pa-label-color font-neue font-15 font-w-500">I commit to purchasing this item if I win the auction.</span>' +
      '<div class="wk-compromiso-error font-neue font-14">Please accept the purchase commitment to place your bid.</div>';
    btn.parentNode.insertBefore(w, btn);
    var p = document.getElementById(PROXY);
    var m = document.getElementById(MAIN);
    if (m) p.checked = m.checked;
    p.addEventListener('change', function () { sync(PROXY); upd(); });
  }

  function bindMain() {
    var m = document.getElementById(MAIN);
    if (!m || m.dataset.ubxProxySync) return;
    m.dataset.ubxProxySync = '1';
    m.addEventListener('change', function () { sync(MAIN); upd(); updMain(); });
  }

  /* Casilla del formulario normal (#bidding-form). Antes solo la ponía el bloque Custom Liquid de la plantilla de producto
     de "Auction Test Jersey"; los productos con la plantilla normal no la tenían. Aquí sale en todas las plantillas.
     Si el bloque también está, el primero que la ponga se queda (los dos revisan el id). */
  function okMain() {
    var m = document.getElementById(MAIN);
    return !!(m && m.checked);
  }

  function styleMain() {
    if (document.getElementById('ubx-compromiso-css')) return;
    var s = document.createElement('style');
    s.id = 'ubx-compromiso-css';
    s.textContent =
      '#bidding-form .wk-compromiso{clear:both;display:flex;flex-wrap:wrap;align-items:center;margin-top:-33px;padding-left:3px;box-sizing:border-box;position:relative;z-index:1}' +
      '#bidding-form .wk-compromiso>span{flex:1;line-height:1.3;margin-left:8px!important}' +
      '#wk-auction #bidding-form .wk-compromiso .wk-compromiso-error{display:none;width:100%;margin-top:6px;color:#ff6b6b!important}';
    document.head.appendChild(s);
  }

  function injectMain() {
    var f = document.getElementById('bidding-form');
    if (!f || document.getElementById(MAIN)) return;
    var p = document.getElementById('is_private');
    var a = p ? p.closest('.noselect') : null;
    var bd = f.querySelector('.form-button-div');
    if (!a && !bd) return;
    styleMain();
    var w = document.createElement('div');
    w.className = 'margin-btm-15 noselect wk-compromiso';
    w.innerHTML =
      '<input type="checkbox" class="pa-checkbox" id="' + MAIN + '">' +
      '<label for="' + MAIN + '" class="pa-bdr"><div class="pa-theme-color">&#10003;</div></label>' +
      '<span class="margin-left-5 pa-label-color font-neue font-15 font-w-500">I commit to purchasing this item if I win the auction.</span>' +
      '<div class="wk-compromiso-error font-neue font-14">Please accept the purchase commitment to place your bid.</div>';
    if (a) a.parentNode.insertBefore(w, a.nextSibling);
    else bd.parentNode.insertBefore(w, bd);
  }

  function updMain() {
    var f = document.getElementById('bidding-form');
    if (!f) return;
    f.classList.toggle('wk-ok', okMain());
    f.querySelectorAll('.wk_submit_bid').forEach(function (b) {
      b.style.opacity = okMain() ? '' : '0.45';
      b.style.cursor = okMain() ? '' : 'not-allowed';
    });
    var e = f.querySelector('.wk-compromiso-error');
    if (e && okMain()) e.style.display = 'none';
    var w = f.querySelector('.wk-compromiso');
    if (w && f.clientWidth) w.style.width = f.clientWidth + 'px';
  }

  function blockMain(ev) {
    var e = document.querySelector('#bidding-form .wk-compromiso-error');
    if (e) e.style.display = 'block';
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('#bidding-form .wk_submit_bid') && !okMain()) blockMain(ev);
  }, true);
  document.addEventListener('keydown', function (ev) {
    var t = ev.target;
    if (ev.key === 'Enter' && t && t.closest && t.closest('#bidding-form') && !okMain()) blockMain(ev);
  }, true);
  window.addEventListener('resize', updMain);

  function block(ev) {
    var e = document.querySelector('#' + FORM + ' .wk-compromiso-error');
    if (e) e.style.display = 'block';
    ev.preventDefault();
    ev.stopPropagation();
    ev.stopImmediatePropagation();
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (t && t.closest && t.closest('#' + FORM + ' .wk_proxy_submit') && !ok()) block(ev);
  }, true);
  document.addEventListener('keydown', function (ev) {
    var t = ev.target;
    if (ev.key === 'Enter' && t && t.closest && t.closest('#' + FORM) && !ok()) block(ev);
  }, true);
  document.addEventListener('submit', function (ev) {
    if (ev.target && ev.target.id === FORM && !ok()) block(ev);
  }, true);

  /* Aviso en vivo si el monto escrito es menor al mínimo permitido (lo toma del mensaje de Webkul). */
  function minAllowed() {
    var s = document.querySelector('#bidding-form .min_bid_amt');
    var n = s ? parseFloat(s.textContent.replace(/[^0-9.]/g, '')) : NaN;
    if (isNaN(n) && typeof window.min_bid_amount === 'number') n = window.min_bid_amount;
    return n;
  }
  function checkMin() {
    var f = document.getElementById('bidding-form');
    var i = document.getElementById('bid_amount');
    if (!f || !i) return;
    var raw = i.value.trim();
    var v = parseFloat(raw.replace(/,/g, ''));
    var min = minAllowed();
    f.classList.toggle('ubx-below-min', raw !== '' && !isNaN(v) && !isNaN(min) && v < min);
  }
  document.addEventListener('input', function (ev) {
    if (ev.target && ev.target.id === 'bid_amount') checkMin();
  }, true);

  /* Parche "Normal & Proxy con un solo botón": la config que lee el script de Webkul (wk_auction_config.enable_proxy_Bid)
     está desactualizada y en la página no viene #bidding_rules, así que nunca convertía pujas grandes en proxy.
     Justo antes del clic en "Place My Bid" agregamos los respaldos que el propio script de Webkul revisa:
     #normal_as_proxy_config = 1 y #bidding_rules con el incremento actual (mínimo permitido − puja actual).
     Webkul decide: si la puja ≥ actual + 2×incremento → proxy; si no → normal. Quitar cuando Webkul arregle la sincronización. */
  function num(t) { return parseFloat(String(t || '').replace(/[^0-9.]/g, '')); }
  function hidden(f, id, val) {
    var e = document.getElementById(id);
    if (!e) { e = document.createElement('input'); e.type = 'hidden'; e.id = id; f.appendChild(e); }
    e.value = val;
  }
  function dropNormalAsProxy() {
    ['normal_as_proxy_config', 'bidding_rules'].forEach(function (id) {
      var e = document.getElementById(id);
      if (e) e.parentNode.removeChild(e);
    });
  }
  /* Mínimo con el que Webkul compara: su variable global min_bid_amount. Cuando la subasta se actualiza en vivo
     puede quedar vieja respecto al mensaje de la página. */
  function webkulMin() {
    var g = window.min_bid_amount;
    /* Igual que Webkul: parseFloat directo (si viene "7,600.00" lo lee como 7), para que su corte quede donde queremos */
    var n = (g === '' || g === undefined || g === null) ? NaN : parseFloat(g);
    return isNaN(n) ? minAllowed() : n;
  }
  function prepareNormalAsProxy(amount) {
    var f = document.getElementById('bidding-form');
    if (!f) return;
    /* Solo si la subasta tiene la puja automática activa (si no, el servidor responde "sww") */
    if (!document.querySelector('#proxy_bidding_form, #wk-auction a.pa-show-modal')) { dropNormalAsProxy(); return; }
    /* Puja actual: la que se ve (#current_bid), porque Webkul la actualiza en vivo cuando otro puja; #current_bid_hidden
       se queda con el valor de cuando cargó la página y daba un incremento enorme (la puja se iba como normal). */
    var shown = document.getElementById('current_bid');
    var cur = document.getElementById('current_bid_hidden');
    var current = Math.max(shown ? num(shown.textContent) || 0 : 0, cur ? num(cur.value) || 0 : 0) || NaN;
    var inc = minAllowed() - current;
    if (isNaN(inc) || inc <= 0) { dropNormalAsProxy(); return; } /* sin pujas previas o sin datos: se queda como puja normal */
    /* Decidimos aquí: desde actual + 2×incremento es proxy; abajo se manda normal sin parche. Antes, con el mínimo
       viejo de Webkul, una puja del mínimo exacto salía como proxy y el servidor la rechazaba ("Minimum proxy bidding amount allowed"). */
    var threshold = current + 2 * inc;
    if (isNaN(amount) || amount < threshold) { dropNormalAsProxy(); return; }
    /* Webkul convierte si puja > su mínimo + rate; calculamos rate con su mismo mínimo para que el corte quede en threshold */
    var rate = Math.max(threshold - 0.01 - webkulMin(), 0.01);
    hidden(f, 'normal_as_proxy_config', '1');
    hidden(f, 'bidding_rules', JSON.stringify([{ bid_from: 0, bid_to: 999999999, rate: rate.toFixed(2) }]));
  }
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest || !t.closest('#bidding-form .wk_submit_bid')) return;
    var i = document.getElementById('bid_amount');
    prepareNormalAsProxy(i ? parseFloat(i.value.replace(/,/g, '')) : NaN);
  }, true);

  /* Invitados: Webkul los manda a /account/login?redirect_url=…, pero con las cuentas nuevas de Shopify ese destino se pierde
     (terminan en su cuenta y la puja no se pone). Cambiamos el destino a /customer_authentication/login?return_to=…, que
     regresa al producto con ?bid=… (o ?pbid=… si fue puja automática); ahí el propio Webkul pone la puja al cargar.
     sso=silent abre la sesión también en la tienda (sin eso Webkul sigue viendo un invitado); Shopify lo quita y conserva lo demás. */
  function loginUrl(u) {
    var a = new URL(u, location.href);
    var back = a.pathname + a.search + (a.search ? '&' : '?') + 'sso=silent';
    return '/customer_authentication/login?return_to=' + encodeURIComponent(back);
  }
  function wrap(sp, name) {
    var orig = sp[name];
    if (typeof orig !== 'function' || orig.ubx) return;
    var w = function (btn) {
      if (name === 'submitBid' && !btn) prepareNormalAsProxy(num(arguments[1])); /* puja que Webkul repone al regresar del login */
      /* Si la puja automática falló ("sww"), Webkul reintenta como normal con proxy=true; sin esto nuestro parche
         la volvía a convertir en automática y se ciclaba sin poner la puja */
      if (name === 'submitBid' && arguments[4] === true) dropNormalAsProxy();
      var before = null;
      try { before = localStorage.getItem('checkout_url'); localStorage.removeItem('checkout_url'); } catch (e) {}
      var r = orig.apply(this, arguments);
      try {
        var after = localStorage.getItem('checkout_url'); /* Webkul solo lo escribe cuando manda al invitado al login */
        if (after) { if (window.ubxWait) window.ubxWait(); location.href = loginUrl(after); }
        else if (before !== null) localStorage.setItem('checkout_url', before);
      } catch (e) {}
      return r;
    };
    w.ubx = true;
    sp[name] = w;
  }
  function wrapAll() {
    var sp = window.spObj;
    if (!sp) return;
    wrap(sp, 'submitBid');
    wrap(sp, 'placeProxyBid');
  }
  if (!window.spObj) {
    try { /* si cargamos antes que Webkul, envolvemos en cuanto define spObj */
      var ubxSp;
      Object.defineProperty(window, 'spObj', { configurable: true, get: function () { return ubxSp; }, set: function (v) { ubxSp = v; wrapAll(); } });
    } catch (e) {}
  }

  function run() { injectMain(); inject(); bindMain(); upd(); updMain(); wrapAll(); }
  run();
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
})();
/* Lista de subastas: la lista de Webkul no trae datos de pujas en tarjetas sin ofertas; agregamos "0 Bid(s)" + Start Bidding Amount para que todas se vean parejas.
   ID y monto se guardan en localStorage: en visitas siguientes aparecen al instante y se refrescan en segundo plano si tienen mas de 10 min. */
(function () {
  var KEY = 'ubx-start-bid-v1', MAX_AGE = 10 * 60 * 1000, store = {}, pending = {};
  try { store = JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) {}
  function save() { try { localStorage.setItem(KEY, JSON.stringify(store)); } catch (e) {} }
  function listParams() {
    var e = performance.getEntriesByType('resource').filter(function (x) { return /callback=getProductsOnAuction/.test(x.name); }).pop();
    return e ? new URL(e.name).searchParams : null;
  }
  function productId(handle) {
    if (store[handle] && store[handle].id) return Promise.resolve(store[handle].id);
    return fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (prod) { return prod.id; });
  }
  function startAmount(handle) {
    if (pending[handle]) return pending[handle];
    pending[handle] = productId(handle).then(function (id) {
      var p = listParams();
      if (!p) throw new Error('ubx: sin parametros de la lista');
      var q = new URL('https://sp-auction.webkul.com/index.php');
      ['p', 'shop_name', 'timediff', 'auction_config', 'widget_config', 'theme_colors', 'active_currency[active]', 'active_currency[rate]', 'rate_from', 'rate_to'].forEach(function (k) { if (p.has(k)) q.searchParams.set(k, p.get(k)); });
      q.searchParams.set('callback', 'biddingform');
      q.searchParams.set('prod_id', id);
      q.searchParams.set('cust_id', '');
      q.searchParams.set('page', 'products');
      return fetch(q.toString()).then(function (r) { return r.text(); }).then(function (t) {
        var html = JSON.parse(t.slice(t.indexOf('(') + 1, t.lastIndexOf(')')));
        var el = new DOMParser().parseFromString(html, 'text/html').querySelector('#start_bid .pa-text-color');
        var amt = el ? el.textContent.trim() : '';
        if (amt) store[handle] = { id: id, amt: amt, t: Date.now() };
        else delete store[handle];
        save();
        return amt;
      });
    }).finally(function () { delete pending[handle]; });
    return pending[handle];
  }
  function row(label, value) {
    var d = document.createElement('div');
    d.innerHTML = '<strong></strong> <span style="white-space:nowrap"></span>';
    d.firstChild.textContent = label;
    d.lastChild.textContent = value;
    return d;
  }
  function fill() {
    document.querySelectorAll('#products_on_auction .wk_products_row > .wkgrid').forEach(function (card) {
      var info = card.querySelector('.wkcol-lg-9');
      if (!info || info.dataset.ubxFilled) return;
      info.dataset.ubxFilled = '1';
      if (/No\. of Bids/i.test(info.textContent)) return;
      var link = info.querySelector('a[href*="/products/"]');
      var btn = info.querySelector('button');
      var btnWrap = btn ? btn.closest('.margin-top-15') : null;
      if (!link) return;
      var handle = link.pathname.split('/products/')[1].split('/')[0];
      var cached = store[handle];
      var amtRow = row('Start Bidding Amount:', cached && cached.amt ? cached.amt : '…');
      info.insertBefore(row('No. of Bids:', '0 Bid(s)'), btnWrap);
      info.insertBefore(amtRow, btnWrap);
      if (cached && cached.amt && Date.now() - cached.t < MAX_AGE) return;
      startAmount(handle).then(function (amt) {
        if (amt) amtRow.lastChild.textContent = amt;
        else amtRow.remove();
      }).catch(function (err) {
        if (!(cached && cached.amt)) amtRow.remove();
        console.warn(err);
      });
    });
  }
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; fill(); });
  }).observe(document.documentElement, { childList: true, subtree: true });
  fill();
})();

/* Unbox Collectibles: tiempo límite para la puja de Webkul.
   Webkul manda la puja por JSONP sin tiempo límite: con mala señal el botón se
   queda cargando y, si falla, solo escribe en la consola. Su petición usa el
   jQuery global, así que aquí se le pone tiempo límite y se avisa al cliente
   debajo del formulario con el que pujó. */
(function () {
  var TIMEOUT_MS = 20000;
  var BID_BUTTONS = { persistbid: '.wk_submit_bid', saveproxybid: '.wk_proxy_submit' };
  var NOTICE_ID = 'ubx-bid-notice';
  var BOX = 'padding:12px 44px 12px 14px;border-radius:8px;background:#1a1a1a;color:#fff;font-size:14px;line-height:1.4;text-align:left;';

  function visible(selector) {
    var list = document.querySelectorAll(selector);
    for (var i = 0; i < list.length; i++) if (list[i].offsetParent) return list[i];
    return null;
  }

  function notice(text, ok, btn) {
    var n = document.getElementById(NOTICE_ID);
    if (!n) {
      n = document.createElement('div');
      n.id = NOTICE_ID;
      n.setAttribute('role', 'alert');
      n.innerHTML = '<span></span><button type="button" aria-label="Cerrar" style="position:absolute;top:8px;right:8px;width:26px;height:26px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.15);color:#fff;font-size:13px;line-height:26px;cursor:pointer">&#10005;</button>';
      n.lastChild.addEventListener('click', function () { n.remove(); });
    }
    if (btn && btn.isConnected) {
      n.style.cssText = BOX + 'position:relative;margin:12px 0;';
      (btn.closest('form') || btn).insertAdjacentElement('afterend', n);
    } else if (!n.isConnected) {
      n.style.cssText = BOX + 'position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483000;max-width:480px;margin:0 auto;box-shadow:0 6px 24px rgba(0,0,0,.45);';
      document.body.appendChild(n);
    }
    n.style.borderLeft = '4px solid ' + (ok ? '#2e7d32' : '#e0a800');
    n.firstChild.textContent = text;
  }

  // Si la respuesta llega después del tiempo límite, jQuery ya quitó su callback.
  function lateResponse(name, btn) {
    window[name] = function (response) {
      if (response && response.msg === 'success') {
        notice('Tu puja sí quedó registrada. Recarga la página para ver el monto actualizado.', true, btn);
      }
    };
  }

  var $ = window.jQuery;
  if (!$ || !$.ajaxPrefilter || $.ubxBidTimeout) return;
  $.ubxBidTimeout = true;
  $.ajaxPrefilter(function (options, original, jqXHR) {
    var name = options.jsonpCallback;
    if (!BID_BUTTONS[name] || String(options.url).indexOf('sp-auction.webkul.com') < 0) return;
    // Webkul pone async: false y, así, jQuery no aplica el tiempo límite.
    options.async = true;
    options.timeout = TIMEOUT_MS;
    var btn = visible(BID_BUTTONS[name]);
    var old = document.getElementById(NOTICE_ID);
    if (old) old.remove();
    jqXHR.fail(function (xhr, status) {
      if (status === 'abort') return;
      if (status === 'timeout') lateResponse(name, btn);
      notice('No pudimos confirmar tu puja por la conexión. Espera unos segundos y revisa si aparece como puja actual antes de volver a pujar.', false, btn);
    });
  });
})();

/* Unbox Collectibles: aviso cuando el cliente vuelve del login y la tienda no lo reconoce.
   Al pujar sin sesión, el tema lo manda a iniciar sesión y lo regresa con ?bid= (o ?pbid=).
   Webkul solo pone esa puja si reconoce la sesión; si no, no hace nada ni avisa.
   Pasa sobre todo dentro de Instagram, Facebook o WhatsApp. */
(function () {
  var params = new URLSearchParams(location.search);
  var amount = Number(params.get('bid') || params.get('pbid'));
  if (!(amount > 0)) return;
  var proxy = !params.get('bid');
  var inApp = /Instagram|FBAN|FBAV|FB_IAB|WhatsApp|Line\/|TikTok|musical_ly|Snapchat/i.test(navigator.userAgent);
  var NOTICE_ID = 'ubx-login-notice';
  var BUTTON = 'display:inline-block;margin-top:10px;padding:8px 14px;border:0;border-radius:6px;background:#fff;color:#111 !important;font-size:14px;font-weight:600;text-decoration:none;cursor:pointer';
  var tries = 0;

  // Mismo criterio que Webkul (wk_shopify_auction.js, líneas 162 y 169).
  function customerId() {
    if (typeof wk_customer_id !== 'undefined') return Number(wk_customer_id);
    var a = document.getElementById('wk-auction');
    return a ? Number(a.getAttribute('cust-id')) : NaN;
  }

  function cleanUrl() {
    ['bid', 'pbid', 'pub', 'quantity', 'username', 'sso'].forEach(function (k) { params.delete(k); });
    var q = params.toString();
    history.replaceState(null, '', location.pathname + (q ? '?' + q : ''));
  }

  function price() {
    var code = window.Shopify && Shopify.currency ? Shopify.currency.active : '';
    return (code ? code + ' ' : '') + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function show(form) {
    var n = document.createElement('div');
    n.id = NOTICE_ID;
    n.setAttribute('role', 'alert');
    n.style.cssText = 'position:relative;margin:12px 0;padding:12px 44px 12px 14px;border-radius:8px;border-left:4px solid #e0a800;background:#1a1a1a;color:#fff;font-size:14px;line-height:1.4;text-align:left';
    var text = 'Tu puja de ' + price() + ' no se hizo porque la tienda no reconoció tu sesión';
    text += inApp
      ? ' dentro de esta app. Abre esta página en Safari o Chrome (menú ··· → «Abrir en el navegador»), inicia sesión y vuelve a pujar.'
      : '. Inicia sesión y vuelve a pujar.';
    n.innerHTML = '<span></span><br><a></a><button type="button" aria-label="Cerrar" style="position:absolute;top:8px;right:8px;width:26px;height:26px;padding:0;border:0;border-radius:50%;background:rgba(255,255,255,.15);color:#fff;font-size:13px;line-height:26px;cursor:pointer">&#10005;</button>';
    n.firstChild.textContent = text;
    var link = n.querySelector('a');
    link.style.cssText = BUTTON;
    if (inApp) {
      link.href = '#';
      link.textContent = 'Copiar enlace';
      link.addEventListener('click', function (ev) {
        ev.preventDefault();
        var url = location.origin + location.pathname;
        var done = function () { link.textContent = '¡Enlace copiado!'; };
        if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { window.prompt('Copia este enlace:', url); });
        else window.prompt('Copia este enlace:', url);
      });
    } else {
      link.href = '/customer_authentication/login?return_to=' + encodeURIComponent(location.pathname);
      link.textContent = 'Iniciar sesión';
    }
    n.lastChild.addEventListener('click', function () { n.remove(); });
    form.insertAdjacentElement('afterend', n);
  }

  function check() {
    var form = document.getElementById('bidding-form');
    if (!form) {
      if (++tries < 60) setTimeout(check, 500);
      return;
    }
    if (customerId() > 0) return; // Webkul pone la puja.
    // Sin ?bid en la URL, una recarga ya no puede pujar sola cuando la sesión aparezca.
    cleanUrl();
    var input = document.getElementById(proxy ? 'proxy_bid_amount' : 'bid_amount');
    if (input && !input.value) input.value = amount;
    if (!document.getElementById(NOTICE_ID)) show(form);
  }

  check();
})();

/* Unbox Collectibles: aviso mientras se confirma la sesión y se pone la puja.
   Si la tienda no reconoce la sesión, la puja pasa por el login silencioso y regresa con ?bid=;
   son varios segundos en los que parecía que la página se había trabado. */
(function () {
  var NOTICE_ID = 'ubx-wait-notice';

  function show(text) {
    var n = document.getElementById(NOTICE_ID);
    if (!n) {
      if (!document.getElementById('ubx-wait-css')) {
        var s = document.createElement('style');
        s.id = 'ubx-wait-css';
        s.textContent = '@keyframes ubx-wait-spin{to{transform:rotate(360deg)}}';
        document.head.appendChild(s);
      }
      n = document.createElement('div');
      n.id = NOTICE_ID;
      n.setAttribute('role', 'status');
      n.style.cssText = 'position:fixed;left:16px;right:16px;bottom:16px;z-index:2147483000;max-width:480px;margin:0 auto;display:flex;align-items:center;gap:10px;padding:12px 14px;border-radius:8px;border-left:4px solid #fff;background:#1a1a1a;color:#fff;font-size:14px;line-height:1.4;text-align:left;box-shadow:0 6px 24px rgba(0,0,0,.45)';
      n.innerHTML = '<span style="flex:none;width:16px;height:16px;border:2px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:ubx-wait-spin .8s linear infinite"></span><span></span>';
      document.body.appendChild(n);
    }
    n.lastChild.textContent = text;
  }

  function hide() {
    var n = document.getElementById(NOTICE_ID);
    if (n) n.remove();
  }

  // Lo llama el envoltorio de la puja (arriba) justo antes de mandar al login.
  window.ubxWait = function () {
    show('Confirmando tu sesión… En unos segundos se hará tu puja. No cierres esta página.');
  };
  // Si regresan con el botón Atrás, la página sale de la caché con el aviso puesto.
  window.addEventListener('pageshow', function (ev) { if (ev.persisted) hide(); });

  // De regreso del login, Webkul pone la puja sola al cargar el widget.
  var params = new URLSearchParams(location.search);
  var amount = Number(params.get('bid') || params.get('pbid'));
  if (!(amount > 0)) return;
  var tries = 0;

  function customerId() {
    if (typeof wk_customer_id != 'undefined') return Number(wk_customer_id);
    var a = document.getElementById('wk-auction');
    return a ? Number(a.getAttribute('cust-id')) : NaN;
  }

  function start() {
    if (!document.getElementById('wk-auction')) {
      if (++tries < 60) setTimeout(start, 500);
      return;
    }
    if (!(customerId() > 0)) return; // sin sesión: el aviso de arriba explica qué pasó
    var code = window.Shopify && Shopify.currency ? Shopify.currency.active : '';
    show('Colocando tu puja de ' + (code ? code + ' ' : '') + amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '…');
    setTimeout(hide, 25000);
  }

  var $ = window.jQuery;
  if ($ && $.ajaxPrefilter) {
    $.ajaxPrefilter(function (options, original, jqXHR) {
      if (options.jsonpCallback === 'persistbid' || options.jsonpCallback === 'saveproxybid') jqXHR.always(hide);
    });
  }
  start();
})();

/* Unbox Collectibles: provincia escrita a mano en el popup "Customer Details" de Webkul.
   Webkul solo trae provincias de algunos países (Guatemala y El Salvador salen vacíos) y Shopify no
   guarda una dirección de Guatemala sin departamento. Shopify sí acepta el nombre escrito ("peten" → "Petén").
   Además, si el guardado falla, Webkul deja el popup abierto sin decir nada. */
(function () {
  var INPUT_ID = 'ubx-province-text';
  var tries = 0;

  function el(id) { return document.getElementById(id); }

  function ensureInput() {
    var select = el('pa_customer_province_field');
    if (!select) return null;
    var input = el(INPUT_ID);
    if (input) return input;
    input = document.createElement('input');
    input.type = 'text';
    input.id = INPUT_ID;
    input.className = 'pa-input-field font-neue';
    input.placeholder = 'Ej. Guatemala, Petén';
    input.autocomplete = 'address-level1';
    input.setAttribute('list', INPUT_ID + '-list');
    var list = document.createElement('datalist');
    list.id = INPUT_ID + '-list';
    select.style.display = 'none';
    select.parentNode.insertBefore(input, select.nextSibling);
    select.parentNode.appendChild(list);
    // Si Webkul sí tiene la lista del país, la usamos como sugerencias.
    input.addEventListener('focus', function () {
      list.innerHTML = '';
      Array.prototype.forEach.call(select.options, function (o) {
        if (o.value && o.value != 'select_option') list.appendChild(new Option(o.value));
      });
    });
    return input;
  }

  function showError(divId, msgId, text) {
    var div = el(divId), msg = el(msgId);
    if (!div || !msg) return;
    msg.innerHTML = '';
    if (text) { var p = document.createElement('p'); p.textContent = text; msg.appendChild(p); }
    div.classList.toggle('pa-hide', !text);
  }

  function finalError(text) { showError('pa_final_error', 'pa_final_error', text); }

  function start() {
    if (!ensureInput() && ++tries < 60) setTimeout(start, 500);
  }

  // Otro país: lo escrito ya no aplica.
  document.addEventListener('change', function (ev) {
    if (ev.target.id != 'pa_customer_country_field') return;
    var input = ensureInput();
    if (input) input.value = '';
  });

  // Antes que Webkul: revisar dirección y provincia, y pasar lo escrito a su selector.
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest || !ev.target.closest('#pa_save_customer_details_auc')) return;
    var input = ensureInput(), select = el('pa_customer_province_field');
    if (!input || !select) return;
    var address = (el('pa_customer_address1_field') || {}).value || '';
    var province = input.value.trim();
    // Webkul pone .pa-hide en los países que cree sin provincias (Guatemala entre ellos), pero el CSS del tema deja el campo visible.
    var needsProvince = getComputedStyle(select.closest('.pa-form')).display != 'none';
    finalError(address.trim() ? '' : 'Escribe tu dirección.');
    showError('pa_customer_details_province_error_div', 'pa_customer_details_province_error_msg',
      needsProvince && !province ? 'Escribe tu departamento o provincia.' : '');
    if (!address.trim() || (needsProvince && !province)) {
      ev.preventDefault();
      ev.stopPropagation();
      return;
    }
    if (!province) return;
    var match = Array.prototype.find.call(select.options, function (o) {
      return o.value.toLowerCase() == province.toLowerCase();
    });
    if (!match) {
      match = new Option(province, province);
      select.appendChild(match);
    }
    select.value = match.value;
  }, true);

  var $ = window.jQuery;
  if ($ && $.ajaxPrefilter) {
    $.ajaxPrefilter(function (options, original, jqXHR) {
      var cb = options.jsonpCallback;
      if (cb === 'persistbid' || cb === 'saveproxybid') {
        // Al abrir el popup, poner la provincia que el cliente ya tenga guardada.
        jqXHR.done(function (r) {
          if (!r || r.msg != 'customer_details_not_found' || !r.customer_details) return;
          setTimeout(function () {
            var input = ensureInput();
            if (input && r.customer_details.province) input.value = r.customer_details.province;
          }, 0);
        });
      }
      if (cb === 'updateCustomerDetails') {
        var failed = function () {
          finalError('No pudimos guardar tus datos. Revisa la dirección y que el departamento o provincia esté bien escrito (por ejemplo: Guatemala, Sacatepéquez, Petén), y vuelve a intentar.');
        };
        // Webkul escribe su propio mensaje en inglés después; el nuestro va encima.
        jqXHR.done(function (r) { if (!r || !r.status) setTimeout(failed, 0); });
        jqXHR.fail(failed);
      }
    });
  }
  start();
})();

/* Unbox Collectibles: ejemplo de teléfono con la clave del país en el popup "Customer Details" de Webkul.
   Webkul no acepta más de 15 caracteres ni más de dos espacios después de la clave
   ("+52 55 1234 5678" lo rechaza en inglés), así que al enviar se quitan espacios y guiones. */
(function () {
  // País (como lo nombra Webkul) → [clave, número de ejemplo]
  var PHONES = {
    'Guatemala': ['502', '5555 1234'], 'El Salvador': ['503', '7012 3456'], 'Honduras': ['504', '9123 4567'],
    'Nicaragua': ['505', '8123 4567'], 'Costa Rica': ['506', '8312 3456'], 'Panama': ['507', '6123 4567'],
    'Belize': ['501', '622 1234'], 'Mexico': ['52', '5512345678'], 'United States': ['1', '2025550123'],
    'Canada': ['1', '4165550123'], 'Dominican Republic': ['1', '8095550123'], 'Puerto Rico': ['1', '7875550123'],
    'Cuba': ['53', '51234567'], 'Colombia': ['57', '3001234567'], 'Venezuela': ['58', '4121234567'],
    'Ecuador': ['593', '991234567'], 'Peru': ['51', '912345678'], 'Bolivia': ['591', '71234567'],
    'Chile': ['56', '912345678'], 'Argentina': ['54', '91123456789'], 'Uruguay': ['598', '94123456'],
    'Paraguay': ['595', '981123456'], 'Brazil': ['55', '11912345678'], 'Spain': ['34', '612345678'],
    'Portugal': ['351', '912345678'], 'France': ['33', '612345678'], 'Italy': ['39', '3123456789'],
    'Germany': ['49', '15123456789'], 'United Kingdom': ['44', '7400123456'], 'Netherlands': ['31', '612345678']
  };

  function el(id) { return document.getElementById(id); }

  function country() { return PHONES[(el('pa_customer_country_field') || {}).value]; }

  function hint() {
    var phone = el('pa_customer_contact_number_field');
    if (!phone) return;
    var c = country();
    phone.placeholder = c ? 'Ej. +' + c[0] + ' ' + c[1] : 'Con la clave del país, ej. +502 5555 1234';
    phone.inputMode = 'tel';
    phone.autocomplete = 'tel';
  }

  document.addEventListener('change', function (ev) {
    if (ev.target.id == 'pa_customer_country_field') hint();
  });
  document.addEventListener('focusin', function (ev) {
    if (ev.target.id == 'pa_customer_contact_number_field') hint();
  });

  // Antes que Webkul valide: "+52 55 1234 5678" → "+52 5512345678".
  document.addEventListener('click', function (ev) {
    if (!ev.target.closest || !ev.target.closest('#pa_save_customer_details_auc')) return;
    var phone = el('pa_customer_contact_number_field');
    if (!phone) return;
    var v = phone.value.trim().replace(/[\s\-().]/g, '');
    var c = country();
    if (c && v.indexOf('+' + c[0]) === 0) v = '+' + c[0] + ' ' + v.slice(c[0].length + 1);
    phone.value = v;
  }, true);

  var tries = 0;
  (function start() {
    if (el('pa_customer_contact_number_field')) hint();
    else if (++tries < 60) setTimeout(start, 500);
  })();

  // Al abrir el popup, Webkul elige el país del cliente sin avisar con "change".
  var $ = window.jQuery;
  if ($ && $.ajaxPrefilter) {
    $.ajaxPrefilter(function (options, original, jqXHR) {
      if (options.jsonpCallback === 'persistbid' || options.jsonpCallback === 'saveproxybid') {
        jqXHR.done(function () {
          setTimeout(function () {
            // Sin país guardado, Guatemala de una vez (casi todos los clientes son de aquí).
            var c = el('pa_customer_country_field');
            if (c && !c.value && c.querySelector('option[value="Guatemala"]')) {
              c.value = 'Guatemala';
              c.dispatchEvent(new Event('change', { bubbles: true }));
            }
            hint();
          }, 0);
        });
      }
    });
  }
})();
